import React, { Component } from "react";
import { Drawer } from "antd";
import Utils from "@/utils/utils";
import sentGAEvent from "@/ga";
import { ReactComponent as Close } from "@/assets/icons/close.svg";
import FileListModalRender from "./children/FileListModalRender";
import { withTranslation } from "react-i18next";
import "@/assets/fileListModal.scss";

class FileListModalFunction extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleDownloadClick = file => {
    Utils.downloadFile(file, file.fileType ? file.fileType : "mp4");
  };

  handleCloseClick = () => {
    if (this.props.fileListModal.type === "cutSuccess") {
      sentGAEvent({
        category: "Cut",
        action: "CutBackEdit",
      });
    }
    if (this.props.fileListModal.type === "mergeSuccess") {
      sentGAEvent({
        category: "Merge",
        action: "MergBackEdit",
      });
    }
    if (this.props.fileListModal.type === "gifSuccess") {
      sentGAEvent({
        category: "ToGif",
        action: "GifBackEdit",
      });
    }
    if (this.props.fileListModal.type === "speedSuccess") {
      sentGAEvent({
        category: "Speed",
        action: "SpeedBackEdit",
      });
    }
    if (this.props.fileListModal.type === "crop_rotateSuccess") {
      sentGAEvent({
        category: "Crop&Rotate",
        action: "Crop&RotateBackEdit",
      });
    }
    if (this.props.fileListModal.type === "resizeSuccess") {
      sentGAEvent({
        category: "Resize",
        action: "ResizeBackEdit",
      });
    }
    if (this.props.fileListModal.type === "removeWatermarkSuccess") {
      sentGAEvent({
        category: "RemoveWatermark",
        action: "RemoveWatermarkBackEdit",
      });
    }
    if (this.props.fileListModal.type === "convertSuccess") {
      sentGAEvent({
        category: "Convert",
        action: "ConvertBackEdit",
      });
    }
    if (this.props.fileListModal.type === "muteSuccess") {
      sentGAEvent({
        category: "SplitAudio",
        action: "SplitAudioBackEdit",
      });
    }
    if (this.props.fileListModal.type === "subtitleSuccess") {
      sentGAEvent({
        category: "AddText",
        action: "TextBackEdit",
      });
    }
    if (this.props.fileListModal.type === "addWatermarkSuccess") {
      sentGAEvent({
        category: "AddMark",
        action: "AddMarkBackEdit",
      });
    }
    if (this.props.fileListModal.type === "addMusicSuccess") {
      sentGAEvent({
        category: "AddMusic",
        action: "MusicBackEdit",
      });
    }
    this.props.handleClose();
  };

  handleEditNew = () => {
    this.props.handleClose();
    Utils.initWork();
    if (this.props.fileListModal.type === "cutSuccess") {
      sentGAEvent({
        category: "Cut",
        action: "CutNew",
      });
    }
    if (this.props.fileListModal.type === "gifSuccess") {
      sentGAEvent({
        category: "ToGif",
        action: "GifNew",
      });
    }
    if (this.props.fileListModal.type === "mergeSuccess") {
      sentGAEvent({
        category: "Merge",
        action: "MergNew",
      });
    }
    if (this.props.fileListModal.type === "speedSuccess") {
      sentGAEvent({
        category: "Speed",
        action: "SpeedNew",
      });
    }
    if (this.props.fileListModal.type === "crop_rotateSuccess") {
      sentGAEvent({
        category: "Crop&Rotate",
        action: "Crop&RotateNew",
      });
    }
    if (this.props.fileListModal.type === "resizeSuccess") {
      sentGAEvent({
        category: "Resize",
        action: "ResizeNew",
      });
    }
    if (this.props.fileListModal.type === "removeWatermarkSuccess") {
      sentGAEvent({
        category: "RemoveWatermark",
        action: "RemoveWatermarkNew",
      });
    }
    if (this.props.fileListModal.type === "convertSuccess") {
      sentGAEvent({
        category: "Convert",
        action: "ConvertNew",
      });
    }
    if (this.props.fileListModal.type === "muteSuccess") {
      sentGAEvent({
        category: "SplitAudio",
        action: "SplitAudioNew",
      });
    }
    if (this.props.fileListModal.type === "subtitleSuccess") {
      sentGAEvent({
        category: "AddText",
        action: "TextNew",
      });
    }
    if (this.props.fileListModal.type === "addWatermarkSuccess") {
      sentGAEvent({
        category: "AddMark",
        action: "AddMarkNew",
      });
    }
    if (this.props.fileListModal.type === "addMusicSuccess") {
      sentGAEvent({
        category: "AddMusic",
        action: "MusicNew",
      });
    }
  };

  handleButtonListClick = type => {
    switch (type) {
      case "delete":
        this.props.handleDeleteModalShow();
        break;
      case "download":
        this.handleDownloadClick();
        break;
      case "editNew":
        this.handleEditNew();
        break;
      default:
        console.log("null");
    }
  };

  render() {
    return (
      <Drawer
        visible={this.props.fileListModal.show}
        mask
        onClose={this.handleCloseClick}
        closeIcon={<Close style={{ color: "#9F9FA1", width: 36, height: 36 }} />}
        footer={null}
        width="100%"
        height="100%"
        getContainer={this.props.fileListModal.getContainer}
        maskClosable={false}
        className="FileListModal"
        placement="bottom"
      >
        <div
          style={{
            textAlign: "center",
            maxWidth: "1268px",
            margin: "auto",
            width: "100%",
            height: "100%",
          }}
        >
          <FileListModalRender
            files={this.props.files}
            fileListModal={this.props.fileListModal}
            handleSelectAll={this.props.handleSelectAll}
            handleSelectClick={this.props.handleSelectClick}
            handleSelectToEditClick={this.props.handleSelectToEditClick}
            handleButtonListClick={this.handleButtonListClick}
            handleDeleteModalShow={this.props.handleDeleteModalShow}
            handleDownloadClick={this.handleDownloadClick}
          />
        </div>
      </Drawer>
    );
  }
}

export default withTranslation(["fileList"])(FileListModalFunction);
